import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { useUrlPagination } from '../../shared/hooks/useUrlPagination.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';
import { EmptyState } from '../../shared/ui/EmptyState';
import { MonitorPlay, Plus } from 'lucide-react';

const PAGE_SIZE = 5;

const FormatsPage = () => {
  const [data, setData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const [searchValue, setSearchValue] = useState(q);
  const [reloadKey, setReloadKey] = useState(0);
  const { page, offset, pageSize, setPage } = useUrlPagination(PAGE_SIZE);

  // Черновик в поле поиска следует за URL (назад/вперёд в браузере)
  useEffect(() => {
    setSearchValue(q);
  }, [q]);

  useEffect(() => {
    let cancelled = false;
    const request = q
      ? apiRequests.events.getFormatsFiltered(q, pageSize, offset)
      : apiRequests.events.getFormats(pageSize, offset);
    request
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((e) => console.error(e));
    return () => {
      cancelled = true;
    };
  }, [q, offset, pageSize, reloadKey]);

  const handleSearch = () => {
    const next = searchValue.trim();
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (next) params.set('q', next);
      else params.delete('q');
      params.delete('page');
      return params;
    });
  };

  const handleDelete = (id) => {
    apiRequests.events.deleteFormat(id).then(() => {
      if (data.items?.length === 1 && page > 1) setPage(page - 1);
      else setReloadKey((k) => k + 1);
    });
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск форматов..."
        createLink="/events/formats/create"
      />

      <div className="mb-3">
        {data.items?.length === 0 ? (
          q ? (
            <EmptyState
              icon={MonitorPlay}
              variant="search"
              title="Формат не найден"
              description={`По запросу «${q}» форматов нет. Проверьте написание или создайте новый.`}
            />
          ) : (
            <EmptyState
              icon={MonitorPlay}
              title="Форматов пока нет"
              description="Формат подсказывает, как проходит событие: онлайн, офлайн или гибридно. Без формата мероприятие не создать."
              action={{ label: 'Добавить формат', to: '/events/formats/create', icon: Plus }}
            />
          )
        ) : (
          data.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[{ label: 'Создано', value: dateToString(item.createdAt) }]}
              editLink={`/events/formats/${item.id}`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination page={page} total={data.totalCount} pageSize={pageSize} onPageChange={setPage} />
    </>
  );
};

export default FormatsPage;
